import { Action } from 'redux';

export const SUPER_ADMIN_GET_PERMISSION_GROUPS =
  'super-admin-define-permission-groups/SUPER_ADMIN_GET_PERMISSION_GROUPS';
export const SUPER_ADMIN_SET_PERMISSION_GROUPS =
  'super-admin-define-permission-groups/SUPER_ADMIN_SET_PERMISSION_GROUPS';

export const SUPER_ADMIN_GET_ALL_PERMISSION_ROLES =
  'super-admin-define-permission-groups/SUPER_ADMIN_GET_ALL_PERMISSION_ROLES';
export const SUPER_ADMIN_SET_ALL_PERMISSION_ROLES =
  'super-admin-define-permission-groups/SUPER_ADMIN_SET_ALL_PERMISSION_ROLES';

export const SUPER_ADMIN_SHOW_PERMISSION_FORM_MODAL = 'super-admin-define-permission-groups/SHOW_PERMISSION_FORM_MODAL';
export const SUPER_ADMIN_HIDE_PERMISSION_FORM_MODAL =
  'super-admin-define-permission-groups/SUPER_ADMIN_HIDE_PERMISSION_FORM_MODAL';

export const SUPER_ADMIN_CREATE_PERMISSION_GROUPS =
  'super-admin-define-permission-groups/SUPER_ADMIN_CREATE_PERMISSION_GROUPS';
export const SUPER_ADMIN_UPDATE_PERMISSION_GROUPS =
  'super-admin-define-permission-groups/SUPER_ADMIN_UPDATE_PERMISSION_GROUPS';
export const SUPER_ADMIN_DELETE_PERMISSION_GROUPS =
  'super-admin-define-permission-groups/SUPER_ADMIN_DELETE_PERMISSION_GROUPS';

export const SUPER_ADMIN_CREATE_USER = 'super-admin-define-permission-groups/SUPER_ADMIN_CREATE_USER';
export const SUPER_ADMIN_UPDATE_USER = 'super-admin-define-permission-groups/SUPER_ADMIN_UPDATE_USER';
export const SUPER_ADMIN_GET_USERS = 'super-admin-define-permission-groups/SUPER_ADMIN_GET_USERS';
export const SUPER_ADMIN_SET_USERS = 'super-admin-define-permission-groups/SUPER_ADMIN_SET_USERS';
export const SUPER_ADMIN_DEACTIVATE_USER = 'super-admin-define-permission-groups/SUPER_ADMIN_DEACTIVATE_USER';

export const SUPER_ADMIN_PERMISSION_GROUPS_EXPORT_FILE_SEND_EMAIL =
  'super-admin-define-permission-groups/SUPER_ADMIN_PERMISSION_GROUPS_EXPORT_FILE_SEND_EMAIL';
export const SUPER_ADMIN_USER_EXPORT_FILE_SEND_EMAIL =
  'super-admin-define-permission-groups/SUPER_ADMIN_USER_EXPORT_FILE_SEND_EMAIL';
export const SUPER_ADMIN_DELETE_USER = 'super-admin-define-permission-groups/SUPER_ADMIN_DELETE_USER';

export const superAdminGetPermissionGroup = () => {
  return {
    type: SUPER_ADMIN_GET_PERMISSION_GROUPS,
  };
};
export const superAdminSetPermissionGroups = (data: any) => {
  return {
    type: SUPER_ADMIN_SET_PERMISSION_GROUPS,
    payload: data,
  };
};

export const superAdminGetAllPermissionRoles = () => {
  return {
    type: SUPER_ADMIN_GET_ALL_PERMISSION_ROLES,
  };
};
export const superAdminSetAllPermissionRoles = (data: any) => {
  return {
    type: SUPER_ADMIN_SET_ALL_PERMISSION_ROLES,
    payload: data,
  };
};

export const superAdminShowPermissionFormModal = () => {
  return {
    type: SUPER_ADMIN_SHOW_PERMISSION_FORM_MODAL,
  };
};
export const superAdminHidePermissionFormModal = () => {
  return {
    type: SUPER_ADMIN_HIDE_PERMISSION_FORM_MODAL,
  };
};
export const superAdminCreatePermissionGroups = (data: any) => {
  return {
    type: SUPER_ADMIN_CREATE_PERMISSION_GROUPS,
    payload: data,
  };
};
export const superAdminUpdatePermissionGroups = (data: any) => {
  return {
    type: SUPER_ADMIN_UPDATE_PERMISSION_GROUPS,
    payload: data,
  };
};
export const superAdminDeletePermissionGroups = (data: any) => {
  return {
    type: SUPER_ADMIN_DELETE_PERMISSION_GROUPS,
    payload: data,
  };
};
export const superAdminGetUsers = () => {
  return {
    type: SUPER_ADMIN_GET_USERS,
  };
};
export const superAdminSetUsers = (data: any) => {
  return {
    type: SUPER_ADMIN_SET_USERS,
    payload: data,
  };
};
export const superAdminCreateUser = (data: any) => {
  return {
    type: SUPER_ADMIN_CREATE_USER,
    payload: data,
  };
};
export const superAdminUpdateUser = (data: any) => {
  return {
    type: SUPER_ADMIN_UPDATE_USER,
    payload: data,
  };
};
export const superAdminDeactivateUser = (data: any) => {
  return {
    type: SUPER_ADMIN_DEACTIVATE_USER,
    payload: data,
  };
};
export const superAdminExportPermissionGroups = (data: any) => {
  return {
    type: SUPER_ADMIN_PERMISSION_GROUPS_EXPORT_FILE_SEND_EMAIL,
    payload: data,
  };
};
export const superAdminExportUser = (data: any) => {
  return {
    type: SUPER_ADMIN_USER_EXPORT_FILE_SEND_EMAIL,
    payload: data,
  };
};
export const superAdminDeleteUser = (data: any) => {
  return {
    type: SUPER_ADMIN_DELETE_USER,
    payload: data,
  };
};

export interface SetPermisssionGroupsAction extends Action<typeof SUPER_ADMIN_SET_PERMISSION_GROUPS> {
  payload: any;
}

export interface SetAllPermissionRolesAction extends Action<typeof SUPER_ADMIN_SET_ALL_PERMISSION_ROLES> {
  payload: any;
}
export interface SetUsersAction extends Action<typeof SUPER_ADMIN_SET_USERS> {
  payload: any;
}

export interface ShowPermissionFormModalAction extends Action<typeof SUPER_ADMIN_SHOW_PERMISSION_FORM_MODAL> {}
export interface HidePermissionFormModalAction extends Action<typeof SUPER_ADMIN_HIDE_PERMISSION_FORM_MODAL> {}

export type SuperAdminDefinePermissionGroupsAction =
  | SetPermisssionGroupsAction
  | SetAllPermissionRolesAction
  | ShowPermissionFormModalAction
  | HidePermissionFormModalAction
  | SetUsersAction;
